import React from 'react'
import PropTypes from 'prop-types'
import EditThingsForm from './EditThingsForm'

const editFormsMap = {
  279: EditThingsForm
}

export default function EditForm ({
  levelTypeId,
  defaultValues,
  onSubmit,
  onCancel
}) {
  const FormComponent = editFormsMap[levelTypeId]
  if (!FormComponent) return null
  return (
    <FormComponent
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      onCancel={onCancel}
    />
  )
}

EditForm.propTypes = {
  levelTypeId: PropTypes.number.isRequired,
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}
